import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from './tab_menu_bar.module.css'
import { Button, Popup } from 'semantic-ui-react'

export const TabMenuBar = ({ props }) => {
	const [isClicked, setIsClicked] = useState(
		localStorage.getItem('shortcut_bar_state') || false
	)
	const [shortcutItems, setShortcutItems] = useState([
		{ name: 'Inicio', active: true },
	])
	const iconName = isClicked ? 'arrow circle down' : 'arrow circle right'

	const scrollContainerRef = useRef(null)

	useEffect(() => {
		const scrollContainer = scrollContainerRef.current

		if (!scrollContainer) return

		const handleWheel = (e) => {
			if (scrollContainer) {
				e.preventDefault()

				// Scroll speed multiplier
				const scrollSpeed = 1.5

				// Scroll horizontally based on vertical wheel movement
				scrollContainer.scrollLeft += e.deltaY * scrollSpeed
			}
		}

		// Add event listener
		scrollContainer.addEventListener('wheel', handleWheel, { passive: false })

		// Clean up
		return () => {
			scrollContainer.removeEventListener('wheel', handleWheel)
		}
	}, [isClicked])

	useEffect(() => {
		const handleUnload = () => {
			const pathname = window.location.pathname
			const existing = JSON.parse(localStorage.getItem('shortcut_list')) || []

			const updated = existing.filter((item) => {
				return item.url != pathname.replace(/^\/|\/$/g, '')
			})

			localStorage.setItem('shortcut_list', JSON.stringify(updated))
		}

		window.addEventListener('beforeunload', handleUnload)

		return () => {
			window.removeEventListener('beforeunload', handleUnload)
		}
	}, [])

	useEffect(() => {
		let divMainContent = document.querySelector('.main-content')
		let divTabMenuBar = document.querySelector('.tabMenuBar')

		if (divTabMenuBar) {
			divMainContent.style.paddingTop = '0px'
		}
	}, [])

	useEffect(() => {
		const existing = JSON.parse(localStorage.getItem('shortcut_list')) || []
		if (existing.length) {
			setShortcutItems([{ name: 'Inicio', active: false }, ...existing])
		}
	}, [localStorage.getItem('shortcut_list')])

	const onClickShortcut = (data) => {
		console.log(data)
		let newArray = shortcutItems.map((item) => {
			return {
				...item,
				active: item.location_file == data.location_file,
			}
		})

		setShortcutItems(newArray)

		localStorage.setItem(
			'shortcut_list',
			JSON.stringify(newArray.filter((item) => item.name != 'Inicio'))
		)

		window.history.pushState({}, '', `/${data.shortcut_address}`)

		props.data.setUpdatedShortcuts(newArray)
	}

	const handleClick = () => {
		setIsClicked(!isClicked)

		localStorage.setItem('shortcut_bar_state', !isClicked)
	}
	return null
	return (
		<div className={`${styles.tab_scroller_container} tabMenuBar`}>
			<Popup
				content={
					isClicked ? 'Ocultar Accesos Rapidos' : 'Mostrar Accesos rapidos'
				}
				trigger={<Button onClick={() => handleClick()} icon={iconName} />}
			/>

			<div
				ref={scrollContainerRef}
				className={`${styles.linksContainer} ${
					isClicked ? styles.linksContainerOpen : ''
				}`}
			>
				<div className={styles.linksWrapper}>
					{shortcutItems.length &&
						shortcutItems.map((link, index) => {
							console.log('link', link)
							return (
								<span
									key={index}
									className={`${styles.link} ${
										link.active ? styles.is_active : ''
									}`}
									onClick={() => onClickShortcut(link)}
								>
									{link.name}
								</span>
							)
						})}
				</div>
			</div>
		</div>
	)
}
